componentRegistryInstance.register('hp-link', 'read', 'hrd.components.form.HpLinkComponent');

hrd.components.form.HpLinkComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.HpLinkComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceReadField: function(field, id, klass) {
		this._super(field, id, 'hp-shortcut');
		let hpLinkInfo = field.data('info');
		if (hpLinkInfo != undefined) {
			var hpCommons = this.getFormInstanceSetting('hpLinkOptions', {});
			hpLinkInfo = $.evaluate(hpLinkInfo, this.settings.reference);

			dashboardInstance.addPermission(id, hpLinkInfo.role).then(() => {
				if (!dashboardInstance.hasPermission(id) && hpLinkInfo.role != undefined) {
					this.hideField(field);
				}
			});

			hpLinkInfo.bgColor = hpLinkInfo.bgColor || hpCommons.bgColor || '#1f77b4';
			hpLinkInfo.color = hpLinkInfo.color || hpCommons.color || '#e6e3e1';
			hpLinkInfo.compact = (hpLinkInfo.compact != undefined) ? hpLinkInfo.compact : (hpCommons.compact != undefined) ? hpCommons.compact : false;

			field.off('click.hp-link').on('click.hp-link', () => {
				if (hpLinkInfo.fn !== undefined) {
					hrd.utils.executeTopFunction(hpLinkInfo.fn);
				} else {
					hrd.utils.hpLink(hpLinkInfo.uri, hpLinkInfo.target === 'top');
				}
			});
			let img;
			if (hpLinkInfo.img) {
				img = $(`<img src="${hrd.globals.contextRoot}/media/themes/flat/images/homepage/${hpLinkInfo.img}" alt="${hpLinkInfo.label}">`);
			} else if (hpLinkInfo.icon) {
				img = $(`<span class="hp-icon f-icon ${hpLinkInfo.icon}"></span>`);
			} else {
				img = $(`<span class="ui-helper-hidden"></span>`);
			}
			img.addClass('hp-picture');

			let label = $(`<div class="hp-shortcut-text"><span>${hpLinkInfo.label}</span></div>`);

			field.append(img).append(label);

			if (hpLinkInfo.compact) {
				label.hide();
				field
					.addClass('compact')
					.attr('title', hpLinkInfo.label)
					.tooltip({
						position: { my: 'left top', at: 'left bottom', collision: 'flipfit' }
					});
				if (hpLinkInfo.icon) {
					img.css({
						'color': hpLinkInfo.color,
						'borderColor': hpLinkInfo.color,
					});
				} else {
					img.css({
						'borderColor': hpLinkInfo.color,
					});
				}
			} else {
				field.css({
					'backgroundColor': hpLinkInfo.bgColor,
					'borderColor': hpLinkInfo.bgColor,
				});
				img.css({
					'borderColor': hpLinkInfo.color,
				});
				label.css({
					'color': hpLinkInfo.color,
				});

				field.off('mouseover.hp-link').on('mouseover.hp-link', (evt) => {
					field.css({
						'backgroundColor': hpLinkInfo.color,
					});
					img.css({
						'borderColor': hpLinkInfo.bgColor,
					});
					label.css({
						'color': hpLinkInfo.bgColor,
					});
				});
				field.off('mouseout.hp-link').on('mouseout.hp-link', function(evt) {
					field.css({
						'backgroundColor': hpLinkInfo.bgColor,
					});
					img.css({
						'borderColor': hpLinkInfo.color,
					});
					label.css({
						'color': hpLinkInfo.color,
					});
				});
			}
		}
	},
	getReadOnlyField: function(field, name, object, options) {
		// do nothing: do not call 'super'
	},
	setReadOnlyField: function(field, value, object, options) {
		// do nothing: do not call 'super'
	},
	resetReadOnlyField: function(field, options) {
		// do nothing: do not call 'super'
	}
});